import { v4 as uuidv4 } from "uuid";
import { ControlValueAccessor, NgControl } from "@angular/forms";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  Injector,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";

import { MedInputSizeType } from "./types";
import { STRING } from "../../constants/string";
import { ControlValueAccessorComponent } from "./ControlValueAccessorComponent";

export type MedInputStateType = "" | "success" | "error";

@Component({
  template: "",
})
export abstract class FieldCoreComponent<T> extends ControlValueAccessorComponent<T>
  implements ControlValueAccessor, AfterViewInit {
  constructor(
    protected injector: Injector,
    protected cd: ChangeDetectorRef,
  ) {
    super();
    this.name = uuidv4();
  }

  private _isDisabled = false;

  name!: string; // the unique name for every field
  ngControl?: NgControl | null;

  @Input() label!: string;
  @Input() inputClass = "";
  @Input() labelClass = "";
  @Input() placeholder = "";
  @Input() required = false;
  @Input() hasErrorPadding = true;
  @Input() state: MedInputStateType = "";
  @Input() size: MedInputSizeType = "";
  @Input() errorMessageKey = "errorMessage";

  @Output() onBlur = new EventEmitter<FocusEvent>();
  @Output() onFocus = new EventEmitter<FocusEvent>();

  get disabled(): boolean {
    return this._isDisabled || this.formControlDisabled;
  }

  get invalid(): boolean {
    return this.ngControl?.invalid && Boolean(this.errorMessage) || false;
  }

  get errorMessage(): string {
    // @ts-ignore
    const { errors: { [this.errorMessageKey]: message } = {} } = this.ngControl || {};
    return message || STRING.EMPTY;
  }

  get availabilityStateClass(): string {
    return this.disabled ? "disabled" : STRING.EMPTY;
  }

  get validationStateClass(): string {
    const { invalid = false, touched = false } = this.ngControl || {};
    return invalid && touched ? "error" : STRING.EMPTY;
  }

  // input classes list
  get classList(): string {
    return [
      this.state,
      this.size,
      this.inputClass,
      this.availabilityStateClass,
      this.validationStateClass,
    ].join(STRING.SPACE);
  }

  @Input() set disabled(isDisabled: boolean) {
    this._isDisabled = isDisabled;
  }

  ngAfterViewInit() {
    this.ngControl = this.injector.get(NgControl, null);
    this.cd.detectChanges();
  }

  emitFocus(event?: any): void {
    if (event?.target?.select) {
      event.target.select();
    }

    this.onTouched();
    this.onFocus.emit(event);
  }
}
